import http from './httpClient';
/* eslint-disable import/prefer-default-export */

export const creatMethodSepa = async (data) => {
  try {
    const token = localStorage.getItem('user-token');
    const result = await http.post('/sepa_account/', data, {
      headers: { Authorization: `Token ${token}` },
    });
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getMethodSepa = async (data) => {
  try {
    const token = localStorage.getItem('user-token');
    const result = await http.get('/sepa_account/', data, {
      headers: { Authorization: `Token ${token}` },
    });
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateMethodSepa = async (data) => {
  try {
    const token = await localStorage.getItem('user-token');
    const result = await http.patch(`/sepa_account/${data.id}/`, data, {
      headers: { Authorization: `Token ${token}` },
    });
    return Promise.resolve(result);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteMethodSepa = async (cod) => {
  try {
    const token = await localStorage.getItem('user-token');
    const { status } = await http.delete(`/sepa_account/${cod}`, {
      headers: { Authorization: `Token ${token}` },
    });
    return Promise.resolve(status);
  } catch (error) {
    return Promise.reject(error);
  }
};
